import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from 'react';
import { GetAccessToken } from "../index";
import { msalConfig } from '../authConfig';
import { useAppConfig } from '../config/AppConfigContext';
export function ProfileData({ onPermissionsFetched , onAgencyFetched }) {
    const { instance, accounts } = useMsal();
    const [data, setData] = useState(null);
    const [Loading, setLoading] = useState(false);
    const config = useAppConfig();

    useEffect(() => {
        fetchProfileData();
        fetchAgency();
    }, []);

    const fetchProfileData = async () => {
        setLoading(true);
        const url = "api/returnportalpermissions/GetData";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);

        try {
            await fetch(url, {
                method: "GET",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    onPermissionsFetched(data); // Send to NavMenu
                    setData(data);
                    setLoading(false);
                    return data;
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    //fetchAgency
    const fetchAgency = async () => {
        const url = "api/ReturnList/GetAgencyCode";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);

        try {
            await fetch(url,
                {
                    method: "GET",
                    headers: new Headers(
                        {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        }),
                })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    onAgencyFetched(data); // Send to NavMenu
                    setData(data);
                    return data;
                })
                .catch(error => {
                    console.error('Error:', error);
                });
               
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
}


